<template>
  <div class="o-item_body o-chnl_body bank-container">
    <!-- 组件&对象：银行渠道 -->
    <div class="c-chnl-box o-bank">
      <h3 class="c-chnl-box_title">
        <img
          alt=""
          v-if="curPayType.f_pay_type"
          :src="iconURL"
          class="c-chnl-box_icon o-chnl-icon_pp"
        />
        <span class="c-chnl-box_txt">{{ curPayType.name }}</span>
      </h3>
      <div class="c-chnl-form">
        <div class="c-chnl-form_group c-chnl-form_group-bank">
          <span class="c-chnl-form_type">儲值面額:</span>
          <div class="c-chnl-form_ctrl">
            <input
              type="text"
              class="c-chnl-form_ipt"
              placeholder="请输入付款金额"
              v-model.lazy="amount"
              @change="computePlus"
            />
          </div>
          <button
            class="c-chnl-form_btn"
            v-if="hasProduct"
            @click.prevent="showDialogTw('product')"
          >
            月卡/禮包
          </button>
        </div>
        <div class="c-chnl-form_group">
          <span class="c-chnl-form_type virtual-account">銀行虛擬帳號:</span>
          <div class="c-chnl-form_ctrl input-count">
            <p
              :class="[
                isNaN(dialog.account) ? 'mark-placeholder' : '',
                'c-chnl-form_ipt'
              ]"
            >
              {{ dialog.account }}
            </p>
            <!-- input type="text" class="c-chnl-form_ipt" placeholder="請獲取銀行虛擬帳號" disabled="disabled" :value="dialog.account"> -->
          </div>
          <button
            class="c-chnl-form_btn c-chnl-form_btn-account"
            @click.prevent="comfirmPayInfo"
          >
            獲取
          </button>
          <p class="c-chnl-form_tips" v-if="!isNaN(dialog.account)">
            *虛擬帳號會在當天24點失效，屆時將無法進行匯款，請重新提交訂單獲取
          </p>
        </div>
      </div>
      <div class="o-bank-info">
        <p class="o-bank-info_item">
          <span class="o-bank-info_key">銀行代碼：</span>
          <span class="o-bank-info_value">013</span>
        </p>
        <p class="o-bank-info_item">
          <span class="o-bank-info_key">銀行名稱：</span>
          <span class="o-bank-info_value">國泰世華銀行-建成分行</span>
        </p>
        <p class="o-bank-info_item">
          <span class="o-bank-info_key">銀行戶名：</span>
          <span class="o-bank-info_value">優勢領航科技有限公司</span>
        </p>
      </div>
      <transition
        name="bank-nav-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <p class="o-ret" v-if="isPlus">
          獲得：
          <span class="o-ret_num">{{ plus.COIN }}</span>
          加碼：
          <span class="o-ret_num">{{ plus.EXTRA_COIN }}</span>
          總共獲得：
          <span class="o-ret_num">
            {{ parseInt(plus.COIN) + parseInt(plus.EXTRA_COIN) }}
          </span>
        </p>
      </transition>
    </div>
    <!-- 对象：bank渠道引导 -->
    <div class="o-guide">
      <!-- 对象：bank导航条 -->
      <ul class="o-navs">
        <li
          :class="[navType == 'more' ? ' o-navs_li o-navs_li-on' : 'o-navs_li']"
          @click.prevent="viewNav('more')"
        >
          更多說明
        </li>
        <li
          :class="[
            navType == 'operate' ? ' o-navs_li o-navs_li-on' : 'o-navs_li'
          ]"
          @click.prevent="viewNav('operate')"
        >
          操作說明
        </li>
        <li
          :class="[
            navType == 'donate' ? ' o-navs_li o-navs_li-on' : 'o-navs_li'
          ]"
          @click.prevent="viewNav('donate')"
        >
          慈善捐款
        </li>
        <li
          :class="[
            navType == 'invoice' ? ' o-navs_li o-navs_li-on' : 'o-navs_li'
          ]"
          @click.prevent="viewNav('invoice')"
        >
          索取發票
        </li>
        <li
          :class="[
            navType == 'e-invoice' ? ' o-navs_li o-navs_li-on' : 'o-navs_li'
          ]"
          @click.prevent="viewNav('e-invoice')"
        >
          載具發票
        </li>
      </ul>
      <!-- 对象：说明 -->
      <div class="o-desc">
        <!-- 对象：更多说明 -->
        <transition
          name="bank-nav-transition"
          enter-active-class="animated fadeIn"
        >
          <p v-if="navType == 'more' && getGameId != 43" class="o-more">
            1、玩家可以選擇儲值面額為：50、100、150、300、350、400、450、
            500、1000、2000、3000、5000、10000、20000、30000、40000、50000、100000(台幣）,
            若實際匯款金額和儲值金額不符將會導致儲值失敗
            ，請牢記匯款金額和匯款帳號。
            <br />
            2、每次交易由銀行系統自動生成一個新的儲值帳號。每個儲值帳號只能使用一次。儲值必須為整數金額。
            <br />
            3、銀行匯款的所有檔位在該檔位首次匯款時均可獲得首儲雙倍元寶返還好康，敬請注意，每個檔位的首儲雙倍返還規則在其他付款管道已啟動過該檔位元雙倍的情況下無法生效，例如：在MyCard或其他管道已啟動過50面額的雙倍返還，則通過銀行匯款儲值50面額無法再獲得首儲雙倍。
          </p>
          <p v-if="navType == 'more' && getGameId == 43" class="o-more">
            1、輸入的金額僅用作計算的參考，並非實際儲值的金額；
            <br />
            <span style="color: red">
              2、匯款金額需按儲值金額檔次進行，否则会影响發遊戲內儲值返利活動和首儲續儲綁鑽贈送，除了贈送的綁鑽，獲得的鑽石還可以额外贈送10%的鑽石加碼。（只限鑽石）
            </span>
            <br />
            3、第三方進行儲值無法激活遊戲內天使賜福活動。
            <br />
            4、玩家可以選擇儲值檔次介紹（台幣）：30、50、90、100、150、300、350、400、450、500、750、1000、1150、1490、2000、3000、5000、10000、20000、30000、40000、50000、100000。
          </p>
        </transition>
        <transition
          name="bank-nav-transition"
          enter-active-class="animated fadeIn"
        >
          <p v-if="navType == 'operate'" class="o-more">
            1、儲值服務時間：
            <br />
            <span class="mark-orange">-銀行網路匯款儲值：轉帳時間：24小時</span>
            <br />
            -ATM轉帳儲值：轉帳時間：24小時
            <br />
            -銀行臨櫃匯款儲值：轉帳時間：9:00-15:30
            <br />
            -郵局匯款儲值： 轉帳時間：8:00-17:00
            <br />
            <span class="mark-orange">
              銀行網路匯款儲值、ATM儲值一般半小時內到帳
            </span>
            ，其餘儲值方式的到帳時間為:週一到週四15：30後匯款需隔天到帳，週五15：30後匯款需下週一到帳。
            <br />
            2、儲值金額將一次性轉為遊戲貨幣，無法分開帳號或同一帳號分多次儲值。
          </p>
        </transition>
        <transition
          name="bank-nav-transition"
          enter-active-class="animated fadeIn"
        >
          <div v-if="navType == 'donate'" class="o-more">
            <p
              class="bank-transfer_desc-row orange-text"
              style="height: auto; width: 100%"
            >
              1.慈善捐贈：我們會將您的愛心傳遞給社團法人台灣偵搜犬協會（網址：
              <a
                class="mark-orange"
                href="//www.tdda.com.tw/tw"
                target="_blank"
              >
                https://www.tdda.com.tw/tw
              </a>
              ），也可以在下方填入您想捐贈的受捐贈機關或團體的捐贈碼，謝謝您！
            </p>
            <div class="o-invoice_group">
              <input
                type="text"
                class="o-invoice_ctrl"
                placeholder="銀行虛擬帳號"
                v-model="donate.donateAccount"
              />
            </div>
            <div class="o-invoice_group">
              <input
                type="text"
                class="o-invoice_ctrl"
                placeholder="捐贈碼"
                v-model="donate.donateCode"
              />
            </div>

            <p class="bank-transfer_desc-row orange-text">
              2.索取發票：我們會郵寄給您發票！
            </p>
            <div class="c-qr">
              <button
                class="c-qr_btn"
                @click.prevent="getDonateCode"
                :disabled="isUnClickable"
                :class="{ disable: isUnClickable }"
              >
                確 認
              </button>
            </div>
          </div>
        </transition>
        <transition
          name="bank-nav-transition"
          enter-active-class="animated fadeIn"
        >
          <div v-if="navType == 'invoice'" class="o-invoice">
            <div class="o-invoice_group">
              <input
                id="J_invo_account"
                class="o-invoice_ctrl"
                placeholder="請獲取銀行虛擬帳號"
                v-model.lazy.number="invoice.account"
              />
            </div>
            <div class="o-invoice_group">
              <input
                type="text"
                class="o-invoice_ctrl"
                placeholder="請輸入真實姓名"
                v-model.lazy="invoice.name"
              />
            </div>
            <div class="o-invoice_group">
              <input
                type="text"
                class="o-invoice_ctrl"
                placeholder="請輸入郵寄地址"
                v-model.lazy="invoice.addr"
              />
            </div>
            <div class="o-invoice_group">
              <input
                type="text"
                class="o-invoice_ctrl"
                placeholder="請輸入郵遞區號"
                v-model.lazy="invoice.addrCode"
              />
            </div>
            <div class="c-qr">
              <button
                class="c-qr_btn"
                @click.prevent="getInvoice"
                :disabled="isUnClickable"
                :class="{ disable: isUnClickable }"
              >
                確 認
              </button>
            </div>
          </div>
          <div class="o-invoice-part dn" v-if="navType === 'e-invoice'">
            <p class="pb10">
              載具選擇 &nbsp;&nbsp;&nbsp;&nbsp;
              <input id="mobile-barcode" type="radio" checked="checked" />
              <label for="mobile-barcode">載具發票</label>
            </p>
            <p class="pb10">
              載具發票：
              <input
                id="barcode-mobile"
                v-model.lazy="oInvoice.barcodeMobile"
                placeholder="必须/开头，只能输入8个字符，示例：/UVGOBQR、/P1+RSRR、/LV.I5P2、/0U5B8+P"
                class="ipt_style"
                type="text"
              />
            </p>
            <p class="pb10">
              銀行虛擬帳號：
              <input
                id="barcode-account"
                v-model.lazy="oInvoice.barcodeAccount"
                placeholder="銀行虛擬帳號"
                class="ipt_style"
                type="text"
              />
            </p>
            <p class="pb10 tips">
              溫馨提示：載具發票請於儲值當日填寫提交，超過儲值當日請點擊索取發票，填寫可收件地址，我們將把紙本發票郵寄給您
            </p>
            <p class="pb10 submit">
              <button
                id="submit-remit-btn1"
                @click.prevent="getOInvoice"
                type="button"
                :disabled="isUnClickable"
                :class="{ disable: isUnClickable }"
                class="p_btn J_submit_remit"
              >
                確 認
              </button>
            </p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Api from '../../utiles/twStore/js/common/api.js';
import globalConfig from '../../utiles/globalConfig';
const mainHost = globalConfig.getMainHost();
export default {
  name: 'bank-vue',
  data() {
    return {
      navType: 'more',
      hasProduct: false,
      isPlus: false, // 是否計算了加碼儲值
      plus: null, // 加碼信息
      state: this.$store.state,
      amount: '', // 金额
      donate: {
        donateAccount: '', // 銀行虛擬賬號
        donateCode: '' // 捐贈碼
      },
      invoice: {
        // 发票相关信息
        account: '', // 银行帐号
        name: '', // 名字
        addr: '', // 邮寄地址
        addrCode: '' // 邮寄区号
      },
      oInvoice: {
        // 载具发票
        barcodeMobile: '', // 手机条码
        barcodeAccount: '' // 银行账号
      },
      channelInfo: {
        // 子渠道作为标识
        name: '銀行匯款', // 页面上显示的渠道文案
        link: '/pay/bank?id=virtual_account', // 子渠道作为id
        logo: 'c-chnl_bank',
        idMark: false // 该字段是个废弃字段（全局搜索后没有引用该字段的地方），同时也应该是isMark，后续维护忽略该字段
      },
      isUnClickable: false
    };
  },
  props: {
    iconURL: {
      type: String,
      required: true
    }
  },
  computed: {
    getVirtualAccount() {
      return this.state.store.pays.bank;
    },
    getGameId() {
      return (
        this.$store.state.store.dialog.ctrl.game.id ||
        this.$store.state.store.user.gameId
      );
    },
    dialog() {
      return this.$store.state.store.dialog;
    },
    curPayType() {
      return this.$store.state.store.curPayType;
    },
    server() {
      return this.$store.state.store.dialog.ctrl.sfq;
    },
    role() {
      return this.$store.state.store.dialog.ctrl.role;
    }
  },
  methods: {
    // 暴露接口方法
    ...mapMutations(['showDialogTw', 'showTip', 'doVerify', 'setPayBankInfo']),

    init() {
      this.$store.state.channelId = this.id;
    },

    viewNav(type) {
      this.navType = type;
    },

    doVerify(forms) {
      let ret = { flag: true };
      for (let i = 0, l = forms.length; i < l; i++) {
        let res = this._verifyRule(forms[i].val, forms[i].rules);
        if (!res.flag) {
          typeof forms[i].call == 'function' && forms[i].call(res);
          ret = res;
          break;
        }
      }
      return ret;
    },

    _verifyRule(val, rules) {
      for (let i = 0, l = rules.length; i < l; i++) {
        let rule = null;
        let msg = null;
        if (typeof rules[i] == 'string') {
          rule = rules[i];
        } else {
          rule = rules[i].rule;
          msg = rules[i].errMsg;
        }
        let run = this.$store.state.store.strategies[rule](val);
        if (!run) return { flag: false, msg: msg };
      }

      return { flag: true };
    },

    verifyAmount() {
      let verifyCall = function (res) {
        // 自动聚焦输入框吧
        this.showTip(res.msg);
      };
      let forms = [
        {
          val: this?.amount,
          rules: [
            {
              rule: 'isNonEmpty',
              errMsg: '請輸入付款金額'
            },
            {
              rule: 'isNumber',
              errMsg: '金額為純數值'
            }
          ],
          call: verifyCall.bind(this)
        }
      ];

      return this.doVerify(forms);
    },

    comfirmPayInfo() {
      let relt = this.verifyAmount();
      if (!relt.flag) return;
      let gameName = this.state.store.dialog.ctrl.game.txt;
      let sfqName = this.server.txt;
      let roleName = this.role.txt;
      let pay = this.curPayType?.pay_type;
      let fpay = this.curPayType?.f_pay_type;
      let currency = this.curPayType?.currency;
      this.setPayBankInfo({
        id: 'bank',
        gameName: gameName,
        sfqName: sfqName,
        roleName: roleName,
        amount: this?.amount,
        pay: pay,
        fpay: fpay,
        currency: currency
      });
      this.showDialogTw('bank-pay');
    },
    // 捐贈碼
    getDonateCode() {
      let self = this;
      if (!/^\d{14}$/.test(this.donate.donateAccount)) {
        self.showTip('請輸入14位數字的虛擬帳號!');
        return;
      }
      if (!/^[0-9]+$/.test(self.donate.donateCode)) {
        self.showTip('請您輸入正確的捐贈碼！');
        return;
      }
      self.isUnClickable = true;
      Api.ajax({
        url: `//gstore.${mainHost}/virtual_account/get_invoice/`,
        type: 'post',
        dataType: 'JSON',
        xhrFields: { withCredentials: true },
        data: {
          virtual_account: self.donate.donateAccount,
          dona_code: self.donate.donateCode
        }
      }).then(
        function (res) {
          self.isUnClickable = false;
          Api.log(res);
          self.showTip(res.msg);
        },
        function (res) {
          self.isUnClickable = false;
          Api.log(res);
          self.showTip(res.msg);
        }
      );
    },
    // 索取发票
    getInvoice() {
      let self = this;
      if (!/^\d{14}$/.test(this.invoice.account)) {
        self.showTip('請輸入14位數字的帳號!');
        return;
      }
      const errTips =
        this.invoice.name === ''
          ? '您還沒有輸入姓名噢'
          : this.invoice.addr === ''
          ? '您還沒有輸入郵寄住址噢'
          : this.invoice.addrCode === ''
          ? '您還沒有輸入郵遞區號噢'
          : '';
      if (errTips) {
        self.showTip(errTips);
        return;
      }
      self.isUnClickable = true;
      Api.ajax({
        url: `//gstore.${mainHost}/virtual_account/get_invoice/`,
        type: 'post',
        dataType: 'JSON',
        xhrFields: { withCredentials: true },
        data: {
          virtual_account: this.invoice.account,
          invoice_title: this.invoice.name,
          mail_addr: this.invoice.addr,
          mail_addr_num: this.invoice.addrCode
        }
      }).then(
        function (res) {
          self.isUnClickable = false;
          Api.log(res);
          self.showTip(res.msg);
        },
        function (res) {
          self.isUnClickable = false;
          Api.log(res);
          self.showTip(res.msg);
        }
      );
    },
    // 获取载具发票
    getOInvoice() {
      let self = this;
      let barcodeMobile = this.oInvoice.barcodeMobile;
      let barcodeAccount = this.oInvoice.barcodeAccount;
      if (!/^\/[0-9A-Z+-.]+$/.test(barcodeMobile)) {
        self.showTip('請輸入正确的載具發票');
        return false;
      } else if (
        barcodeAccount.length != 14 ||
        barcodeAccount === '銀行虛擬帳號'
      ) {
        self.showTip('請輸入14位數字的帳號!');
        return false;
      }
      self.isUnClickable = true;
      Api.ajax({
        url: `//gstore.${mainHost}/virtual_account/get_invoice/`,
        type: 'POST',
        xhrFields: { withCredentials: true },
        dataType: 'JSON',
        data: {
          invoice_phone: barcodeMobile,
          virtual_account: barcodeAccount
        }
      }).then(
        function (res) {
          self.isUnClickable = false;
          self.showTip(res.msg);
        },
        function (res) {
          self.isUnClickable = false;
          self.showTip(res.msg);
        }
      );
    },
    /**
     * 計算儲值加碼信息
     * @return {[type]} [description]
     */
    computePlus() {
      let relt = this.verifyAmount();
      if (!relt.flag) {
        this.isPlus = false;
        return;
      }

      let game = this.state.store.dialog.ctrl.game;

      let succ = function (res) {
        Api.log(res);
        this.isPlus = true;
        this.plus = res.data;
      };
      let fail = function (res) {
        Api.log(res);
        this.showTip(res.msg);
        this.isPlus = false;
      };
      Api.ajax({
        url: `//gstore.${mainHost}/virtual_account/calc_coin`,
        type: 'get',
        dataType: 'jsonp',
        data: {
          game_id: game.id,
          amount: this?.amount
        }
      }).then(succ.bind(this), fail.bind(this));
    }
  },
  created() {
    this.init();
  }
};
</script>
